import ClientUtils from '../utils/http-clients';
import Settings from '../resources/settings';

const baseUrl = Settings.API_BASE_PATH + '/gateway/api';

export default {
  getReportQueue: (educatorBid, queryParams) => {
    const url = `${baseUrl}/educator/${educatorBid}/reportstatus`;

    return ClientUtils.makeGetRequest(url, queryParams);
  },
  deleteReports: (requestIdList, queryParams) => {
    const url = `${baseUrl}/reportstatus/delete-batch`;
    const payload = { requestIdList };

    return ClientUtils.makePutRequest(url, payload, queryParams);
  },
};
